import React, { useEffect } from 'react'
import { CustomerCardModel } from '../models/CustomerCardModel';
import { TreeSelect } from 'antd';
import { TreatmentModel } from '../models/superbit-api-models';
import { RootState } from '../app-context/store';
import { useDispatch, useSelector } from 'react-redux';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';

interface EditReferenceTreatmentProps {
    customerId: string;
    onClose: () => void;
    onSave: () => void;
    show: boolean;
    treatment: TreatmentModel;
}

const dic = {
    "policies": "פוליסות",
    "sues": "תביעות",
    "offers": "הצעות",
    "leads": "לידים",
} as const;


const EditReferenceTreatment = (props: EditReferenceTreatmentProps) => {

    const dispatch = useDispatch();

    const customerModel = new CustomerCardModel();

    const [treatmentsData, setTreatmentsData] = React.useState<TreatmentModel>();
    const [treeTreatmentData, setTreeTreatmentData] = React.useState<any[]>([]);
    const [chooseRelation, setChooseRelation] = React.useState<any>(null);

    const createTreatmentFrom = useSelector((state: RootState) => state.tasks.createTreatmentFrom);

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);


    useEffect(() => {
        if (props.customerId && props.customerId.length > 0) {
            fetchDataRelations();
        }
    }, []);


    const fetchDataRelations = async () => {
        if (props.treatment.id === undefined || props.treatment.id === null) return;

        const data = await customerModel.getAssignment(props.treatment.id);
        if (data) {
            setTreatmentsData(data);

            const storedRelations = sessionStorage.getItem(`treatmentsRelations-${props.customerId}`);
            if (storedRelations) {
                const relationsData = JSON.parse(storedRelations);
                if (relationsData) {
                    setRelationsData(relationsData);
                    return;
                }
            }
            const relationsData = await customerModel.treatmentsLoadRelations(props.customerId);
            sessionStorage.setItem(`treatmentsRelations-${props.customerId}`, JSON.stringify(relationsData));
            console.log('relationsData', relationsData);
            if (relationsData) {
                setRelationsData(relationsData);
            }
        }
    }


    const setRelationsData = (relationDataArg: any) => {
        const relationsData = relationDataArg;
        if (relationsData) {
            if (relationsData.leads && relationsData.leads.length > 0) {
                relationsData.leads.map((lead: any) => {
                    if (lead.offers && lead.offers.length > 0) {
                        let offers = [...lead.offers];
                        relationsData['offers'] = offers;
                    }
                })
            }
            const relationsDataKeys = Object.keys(relationsData);
            const relationsDataList: any[] = [];
            relationsDataKeys.forEach((k: string, idx: number) => {
                if (k !== 'policyRelated' && k !== 'leadRelated' && k !== 'sueRelated' && k !== 'open' && k !== 'elementaryInsurancePolicies' &&
                    //  (createTreatmentFrom.type !== 'lead' || k !== 'leads')) {
                    k !== 'leads') {

                    const relation = relationsData[k];
                    const relationData: any = {
                        title: dic[k as keyof typeof dic] ? dic[k as keyof typeof dic] : k,
                        value: idx,
                        key: idx,
                        selectable: false,
                        type: k,
                    }
                    if (relation && relation.length > 0) {
                        const children = relation.map((c: any, i: number) => {
                            console.log('c', c)
                            return {
                                title: k == 'policies' ? c.policyNumber : k == 'sues' ? c.sueNumber ? c.sueNumber + "-" + c.internalNumber : "0-" + c.internalNumber : k == "leads" ? c.identifier : c.offerIdentity,
                                value: c.id,
                                key: c.id,
                                selectable: true,
                                type: k == 'policies' ? 'policies' : k == 'sues' ? 'sues' : k == 'leads' ? 'leads' : 'offers'
                            }
                        })
                        relationData["children"] = children;
                    }
                    relationsDataList.push(relationData);
                }
            })
            setTreeTreatmentData(relationsDataList);
        }

    }

    // const onClear = () => {
    //     const data = treatmentsData as any;
    //     if (data.policyRelatedId) {
    //         data.policyRelatedId = undefined;
    //     }
    //     if (data.leadRelatedId) {
    //         data.leadRelatedId = undefined;
    //     }
    //     if (data.sueRelatedId) {
    //         data.sueRelatedId = undefined;
    //     }
    //     if (data.offerRelatedId) {
    //         data.offerRelatedId = undefined;
    //     }
    //     setChooseRelation('');
    //     setTreatmentsData(data);
    // }


    const onChangeRelations = (v: any) => {
        const data = treatmentsData as TreatmentModel;
        let selectedItem = null;
        // need to check whiche branch in tree data treeTreatmentData  is selected if is policies or leads or sues
        for (let i = 0; i < treeTreatmentData.length; i++) {
            let Item = treeTreatmentData[i].children && treeTreatmentData[i].children.length > 0 && treeTreatmentData[i].children.find((a: any) => a.key == v);
            if (Item) {
                console.log('Item', Item)
                selectedItem = Item;
            }
        }

        if (selectedItem) {
            switch (selectedItem.type) {
                case 'policies':
                    data["policyRelatedId"] = v;
                    break;
                case 'leads':
                    data["leadRelatedId"] = v;
                    break;
                case 'sues':
                    data["sueRelatedId"] = v;
                    break;
                case 'offers':
                    data["offerRelatedId"] = v;
                    break;
                default:

            }
        }
        setChooseRelation(v);
        setTreatmentsData(data);
    }

    const saveTreatment = async () => {
        const data = treatmentsData as TreatmentModel;
        try {

            const res = await customerModel.treatmentsUpsertTreatment(data);
            console.log('res', res)
            if (res && res.label === "טיפול שוטף נוצר בהצלחה!" || res.label === "טיפול שוטף עודכן בהצלחה!") {

                console.log('saveTreatment', res);
                // props.showPopUpMessage('טיפול שוטף מסוג תיעוד נוצר בהצלחה');
                props.onClose()

                if (leadIdForTreatment && leadIdForTreatment.length > 0) {

                    dispatch(setReloadLeadTreatments(true));
                }
            }
        } catch (error) {
            console.log('EditReferenceTreatment saveTreatment')
            console.log('error', error)

        }
    }


    return (
        <div className={`popup-wrapper small-warning`} style={{ position: 'fixed' }}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e: any) => props.onClose()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {/* {props.messageTitle} */}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className={`parameter-item`}>
                            <div className="field">
                                <div className="title">
                                    שייך ל
                                </div>
                                <div className="value">
                                    <TreeSelect
                                        treeLine
                                        placeholder='שייך ל'
                                        showSearch
                                        style={{
                                            width: '100%',
                                        }}
                                        dropdownStyle={{
                                            maxHeight: 400,
                                            overflow: 'auto',
                                        }}
                                        allowClear
                                        onChange={(v: any) => onChangeRelations(v)}
                                        treeData={treeTreatmentData}
                                        value={chooseRelation}
                                    // disabled={this.isRefDisabled()}
                                    />

                                </div>
                                <div className='error-message'>
                                    שדה חובה
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer" onClick={saveTreatment}>
                            שמור
                        </button>

                        <button className="button white blue-border pointer" onClick={(e: any) => props.onClose()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default EditReferenceTreatment